const TRACE_ENABLED =
  typeof import.meta !== "undefined" &&
  import.meta.env &&
  import.meta.env.DEV &&
  (typeof window === "undefined" || window.__ROUTE_TELEMETRY__ !== false);

export function traceRouteResolve(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[ROUTE_RESOLVE_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceNav(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[NAV_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceLocaleProvider(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[LOCALE_PROVIDER_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceSprint1BNavRefactor(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[SPRINT_1B_NAV_REFACTOR_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceUsToEnRedirect(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[US_TO_EN_REDIRECT_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceInternationalShell(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[INTERNATIONAL_SHELL_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelSearchOnly(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[HOTEL_SEARCH_ONLY_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelOnlySearchUi(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[HOTEL_ONLY_SEARCH_UI_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelProfileRoute(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[HOTEL_PROFILE_ROUTE_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelProfileI18n(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[HOTEL_PROFILE_I18N_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelOfferRoute(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[HOTEL_OFFER_ROUTE_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceInternationalHotelOfferI18n(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[INTERNATIONAL_HOTEL_OFFER_I18N_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelOfferLocalePayload(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[HOTEL_OFFER_LOCALE_PAYLOAD_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceNonHebrewHebrewTextBlock(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[NON_HEBREW_HEBREW_TEXT_BLOCK_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceNonHebrewRouteBlock(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[NON_HEBREW_ROUTE_BLOCK_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceLanguageSwitchRoute(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[LANGUAGE_SWITCH_ROUTE_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceLoginLocaleFlow(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[LOGIN_LOCALE_FLOW_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceAgentLanguageSwitchDisabled(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[AGENT_LANGUAGE_SWITCH_DISABLED_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceRoomRatesLtr(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[ROOM_RATES_LTR_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceRoomRatesI18n(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[ROOM_RATES_I18N_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelOfferLoad(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[HOTEL_OFFER_LOAD_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelOfferNotFound(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[HOTEL_OFFER_NOT_FOUND_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelOfferNavState(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[HOTEL_OFFER_NAV_STATE_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelOfferLink(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[HOTEL_OFFER_LINK_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelFlowContext(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[HOTEL_FLOW_CONTEXT_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceInternationalOfferLayout(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[INTERNATIONAL_OFFER_LAYOUT_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceInternationalBookingLayout(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[INTERNATIONAL_BOOKING_LAYOUT_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceInternationalOfferI18n(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[INTERNATIONAL_OFFER_I18N_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceInternationalMarkupCalculator(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[INTERNATIONAL_MARKUP_CALCULATOR_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

export function traceInternationalHotelSummaryCard(payload) {
  if (!TRACE_ENABLED) return;
  try {
    console.debug("[INTERNATIONAL_HOTEL_SUMMARY_CARD_TRACE]", payload);
  } catch {
    /* ignore */
  }
}
